﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateOrder = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateActiveDrivers_1 = require("./StateActiveDrivers");
class StateOrder extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageOrder, "Order", true);
        const c = this.page.ctrls;
        c.btnChangePrice.onclick = () => this._tryChangePrice();
        c.btnUntake.onclick = () => this._tryUntake();
        c.btnTake.onclick = () => this._tryTake();
        c.btnCancel.onclick = () => this._tryCancel();
        c.btnComplete.onclick = () => this._tryComplete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!args)
                return gs_1.StateRunResultEnum.Failed;
            if (args.id)
                this._order = yield this.lockgui(this.app.api.admin.activeManager.getOrder(args.id));
            if (!this._order)
                return gs_1.StateRunResultEnum.Failed;
            this._urlArgs["id"] = this._order.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._order)
                this.setLabel(this.title + ` #${this._order.id}`);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            const fromLocation = this._order.route.locations[0];
            const toLocation = this._order.route.locations[this._order.route.locations.length - 1];
            const ctrl = this.page.ctrls;
            ctrl.lOrderInfo.html = '';
            let info = `<b>Order info</b><br>` +
                `State: ${this._order.state}<br>` +
                `From: ${fromLocation.addressFull}<br>` +
                `To: ${toLocation.addressFull}<br>` +
                `Start time: ${gs.date.getShortTime(this._order.route.departureTime)}<br>`;
            `State: ${this._order.state}<br>`;
            if (!this._order.finalPrice)
                info += `Est.price: ${this._order.estimatedPrice}<br>`;
            else
                info += `Final price: ${this._order.finalPrice}<br>`;
            if (this._order.changes)
                if (this._order.changes.length > 0) {
                    info += `<br><b>Changes</b>:<br>`;
                    for (const change of this._order.changes) {
                        info += `${gs.date.getShortTime(change.created)} ${change.state} ${change.comment}<br>`;
                    }
                }
            if (this._order.priceChanges)
                if (this._order.priceChanges.length > 0) {
                    info += `<br><b>Price changes</b>:<br>`;
                    for (const change of this._order.priceChanges) {
                        let delta = change.priceChange.toString();
                        if (change.priceChange > 0)
                            delta = "+" + delta;
                        info += `${gs.date.getShortTime(change.created)} ${delta} ${change.reason}<br>`;
                    }
                }
            if (this._order.finalPrice)
                info += `<br><b>Check</b>: <br>${gs.text.replaceAll(this._order.finalCheck, '\r\n', "<br>")}<br><br>`;
            ctrl.lOrderInfo.html = info;
            ctrl.formChangePrice.hide();
            ctrl.blockControl.hide();
            if (this._order.isActive) {
                ctrl.formChangePrice.show();
                ctrl.blockControl.show();
            }
        });
    }
    _tryChangePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.page.ctrls.formChangePrice.getFormData();
            if (!data)
                return;
            const req = new models_1.ChangePriceOrderRequest(data);
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.changeActiveOrderPrice(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.page.ctrls.formChangePrice.fillFormData({ priceDelta: 0, reason: "" });
            yield this.fill();
        });
    }
    _tryUntake() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            if (!this._order.driverId) {
                new modalCom.DialogOk("There is no driver already").show();
                return;
            }
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.untakeActiveOrderForDriver(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
            yield new modalCom.DialogOk("Driver unlinked").show();
        });
    }
    _tryTake() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            if (this._order.driverId) {
                new modalCom.DialogOk("Driver already linked").show();
                return;
            }
            const driver = yield StateActiveDrivers_1.StateActiveDrivers.SelectActiveDriver();
            if (!driver)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.takeActiveOrderForDriver(driver.driver.userId, req));
            if (!responce)
                return;
            this._order = responce;
            yield gs_1.StateGS.Run(StateOrder, { id: this._order.id });
            yield new modalCom.DialogOk("Driver linked").show();
        });
    }
    _tryCancel() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.cancelActiveOrder(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
        });
    }
    _tryComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.completeActiveOrderAndWaitPay(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
        });
    }
}
exports.StateOrder = StateOrder;
StateOrder.StateName = "order";
//# sourceMappingURL=StateOrder.js.map